// extracted by mini-css-extract-plugin
export default {"MessageContainer":"ErrorMessage_MessageContainer__un4xZ"};